module.exports = __webpack_public_path__ + "static/media/barrel.438a9b17.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/StandAlone/barrel.svg
// module id = 328
// module chunks = 0